module.exports = __webpack_public_path__ + "img/logo-barrionuevo.57e6f002.png";